"use client";

import React from "react";

import { UseFormRegister } from "react-hook-form";

import { TextInputProps } from "@/TS/Interfaces/global_interfaces";

function HocTextInput(
  Component: React.ComponentType<TextInputProps>,
  loading: boolean,
  register: UseFormRegister<any>,
) {
  return (props: TextInputProps) => {
    return <Component {...props} loading={loading} register={register} />;
  };
}

export default HocTextInput;
